"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInvsLineItems = exports.getReptInvsLineItems = exports.makeGetLineItems = void 0;
var CSV = __importStar(require("csv-stringify/browser/esm/sync"));
var get_1 = __importDefault(require("lodash/get"));
var pick_1 = __importDefault(require("lodash/pick"));
var fieldProcessors_1 = require("utils/fieldProcessors");
var lIFields = ['Description', 'Item.Name', 'UnitAmount', 'LineAmount', 'TaxAmount', 'Quantity', 'AccountCode'];
var makeGetLineItems = function (idxCol, outerFields, csvPrefix) { return function (invoices, xeroConn) {
    var _a;
    var csvHeaders = __spreadArray(__spreadArray([idxCol], __read(outerFields), false), __read(lIFields.map(function (field) { return "lI.".concat(field); })), false);
    var lines = invoices
        .map(function (item, idx) { return item.LineItems.map(function (lI) {
        var _a;
        return (__assign(__assign((_a = {}, _a[idxCol] = idx, _a), (0, pick_1.default)(item, outerFields)), { lI: (0, pick_1.default)(lI, lIFields) }));
    }); }).flat();
    var sanitizedLines = lines.map(function (line) { return csvHeaders.map(function (header) {
        var value = (0, get_1.default)(line, header);
        return typeof value === 'string' ? value.replace(/#/g, ' ') : value;
    }); });
    var csvStr = CSV.stringify(__spreadArray([csvHeaders], __read(sanitizedLines), false));
    (0, fieldProcessors_1.saveAsCSV)(csvStr, "".concat(csvPrefix, "-").concat((_a = xeroConn === null || xeroConn === void 0 ? void 0 : xeroConn.tenantName) === null || _a === void 0 ? void 0 : _a.replace(/[^a-z]/gi, ''), " - ").concat(new Date().toJSON(), ".csv"));
}; };
exports.makeGetLineItems = makeGetLineItems;
var rIFields = [
    'RepeatingInvoiceID', 'Reference', 'Schedule.NextScheduledDateString', 'Status', 'Type', 'Contact.Name', 'SubTotal', 'TotalTax',
    'LineAmountTypes', 'CurrencyCode',
];
exports.getReptInvsLineItems = (0, exports.makeGetLineItems)('repeatingInvIdx', rIFields, 'ReptInv');
var invFields = [
    'InvoiceID', 'Reference', 'DateString', 'DueDateString', 'Status', 'Type', 'Contact.Name', 'SubTotal', 'TotalTax', 'Total',
    'CurrencyCode',
];
exports.getInvsLineItems = (0, exports.makeGetLineItems)('invIdx', invFields, 'Inv');
